/**
 * coinfix cms system
 *
 * Created by gaoerjun on 2019-08-21 .
 */

const NAME_PRE_URL = 'btcchat://resolve?domain=';
const ID_PRE_URL = 'btcchat://join?invite='
let AppManager = function (_groupKey, _androidDowndUrl, _androidCallBack, _iosCallBack, _lan, _appType, _iosUpdate, _andridUpdate) {
  let $this = this;
  $this.isPriviteLink = window.location.href.indexOf("+") > 0;
  $this.canOpenIosApp = true
  $this.canOpenAndroidApp = true
  $this.iostime1 = ''
  $this.adroidtime1 = ''
  $this.openAppDuration = 1000
  _groupKey = _groupKey.replace("+", '')
  $this.appconfig = {
    ios: {
      scheme: $this.isPriviteLink ? ID_PRE_URL + _groupKey : NAME_PRE_URL + _groupKey,
      downloadurl: ''
    },
    android: {
      scheme: $this.isPriviteLink ? ID_PRE_URL + _groupKey : NAME_PRE_URL + _groupKey,
      downloadurl: _androidDowndUrl
    }
  }
  $this.openIOSAPP = function () {
    console.log('进来了')
    console.log('this.appType ...1')
    if (!$this.canOpenIosApp) {
      return
    }
    let appconfig = $this.appconfig.ios
    // 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP
    let loadDateTime = new Date()
    window.setTimeout(function () {
      let timeOutDateTime = new Date();
      if (_iosCallBack) {
        _iosCallBack();
      }
      // vm.show.maskShow = false
      // vm.show.iosShow = true
      if (timeOutDateTime - loadDateTime < 5000) {
        console.log('未安装app6111')
        if (_lan === 'en') {
          location.href = '/iospage/' + _groupKey + '?lan=en' + (_appType === 'pro' ? '&appType=pro' : '');
        } else {
          location.href = '/iospage/' + _groupKey + (_appType === 'pro' ? '?appType=pro' : '');
        }
      } else {
        console.log('安装了app')
        if (!_iosUpdate) {
          window.close()
        }
      }
    }, 1000)


    console.log(window.location.href.indexOf("+") > 0)
    console.log($this.isPriviteLink)
    console.log(appconfig)
    if (!_iosUpdate) {
      location.href = appconfig.scheme
    }
  }
  /***
   * android 设备端打开app的方法
   * @param _type
   */
  $this.openAndroidAPP = function () {
    if (!$this.canOpenAndroidApp) {
      return
    }
    let appconfig = $this.appconfig.android
    // 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP
    $this.adroidtime1 = Date.now()
    $this.canOpenAndroidApp = false
    setTimeout(function () {
      $this.canOpenAndroidApp = true
      let t2 = Date.now()
      if (_androidCallBack) {
        _androidCallBack();
      }
      // vm.show.maskShow = false
      // vm.show.androidShow = true
      if ($this.adroidtime1 && (t2 - $this.adroidtime1 > $this.openAppDuration - 0 + 50)) {
        console.log('安装了app')
      } else {
        if (_lan === 'en') {
          location.href = '/androidpage/' + _groupKey + '?lan=en' + (_appType === 'pro' ? '&appType=pro' : '');
        } else {
          location.href = '/androidpage/' + _groupKey + (_appType === 'pro' ? '?appType=pro' : '');
        }
        console.log('未安装app7')
      }
    }.bind($this), $this.openAppDuration)
    if (!_andridUpdate) {
      let iframe = document.createElement('iframe')
      iframe.src = appconfig.scheme
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
      location.href = appconfig.scheme
    }
  }
}
export default AppManager;


// WEBPACK FOOTER //
// ./components/AppManager.js